import { Routine } from 'redux-saga-routines';
import { call, put, takeEvery, all } from 'redux-saga/effects';
import { getRefForManualInput } from '../../services/referenceService';
import { getRefForManualInputRoutine } from './routines';

function* getRefForManualInputReq({ payload }: Routine<any>) {
  try {
    const ref = yield call(getRefForManualInput, payload);
    if (ref) {
      yield put(getRefForManualInputRoutine.success(ref));
    } else {
      yield put(getRefForManualInputRoutine.failure());
    }
  } catch (error) {
    yield put(getRefForManualInputRoutine.failure(error.message));
  }
}

function* watchGetRefForManualInput() {
  yield takeEvery(getRefForManualInputRoutine.TRIGGER, getRefForManualInputReq);
}

export default function* manualInputSaga() {
  yield all([watchGetRefForManualInput()]);
}
